import { useCallback } from 'react';

interface ScrollToTopOptions {
  behavior?: 'auto' | 'smooth';
  top?: number;
  left?: number;
}

export const useScrollToTop = () => {
  const scrollToTop = useCallback((options: ScrollToTopOptions = {}) => {
    const {
      behavior = 'smooth',
      top = 0,
      left = 0
    } = options;

    // 检查是否已经在目标位置
    if (window.pageYOffset === top && window.pageXOffset === left) {
      return;
    }

    window.scrollTo({
      top,
      left,
      behavior
    });
  }, []);

  const scrollToElement = useCallback((
    element: HTMLElement | string,
    options: ScrollToTopOptions = {}
  ) => {
    const {
      behavior = 'smooth'
    } = options;

    let targetElement: HTMLElement | null = null;

    if (typeof element === 'string') {
      targetElement = document.querySelector(element);
    } else {
      targetElement = element;
    }

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior,
        block: 'start',
        inline: 'nearest'
      });
    }
  }, []);

  const isAtTop = useCallback(() => {
    return window.pageYOffset === 0;
  }, []);

  return {
    scrollToTop,
    scrollToElement,
    isAtTop
  };
};
